import { Injectable } from '@angular/core';
import { AzureBlobStorageService } from '../baseServices/azure-blob-storage.service';
import { BlobType } from '../enums/blob-storage/blob-type.enum';
import { dataUrlToBlob } from '../utils/converters/to-blob.util';
import { defer, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FormDocumentVideoUploadService {
  constructor(private azureBlobStorageService: AzureBlobStorageService) {}

  uploadVideo(fileName: string, dataUrl: string): Observable<string> {
    return defer(() => {
      const blob = dataUrlToBlob(dataUrl);

      // Creating a File directly using File constructor does not set file name correctly on iOS
      const file = Object.assign(blob, { name: fileName });

      return this.azureBlobStorageService.uploadInChunks(file, BlobType.VIDEO);
    });
  }
}
